import { createSelector, Selector } from 'reselect';
import { RootReducer } from '../store.types';
import { DealsStateType } from './deals.reducer';

const selectDealsRoot = (state: RootReducer): DealsStateType => state.deals;

export const selectCurrentDeal = createSelector(selectDealsRoot, dealsRoot => dealsRoot.deal);

export const selectDealId: Selector<RootReducer, string> = createSelector(selectCurrentDeal, deal => deal?.id || '');
